import { Directive } from '@angular/core';
import { Validator, AbstractControl, NG_VALIDATORS } from '@angular/forms';

export function ValidateMinore(control: AbstractControl): {[key: string]: any} | null  {


    if (control.parent && control.parent.get('dataNascita') && control.parent.get('dataNascita').value) {
        const today = new Date();
        const birthDate = new Date(control.parent.get('dataNascita').value);
        let age = today.getFullYear() - birthDate.getFullYear();
        const m = today.getMonth() - birthDate.getMonth();
        if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
            age--;
        }
        if (age >= 18) {
            return { minorenotvalid: true };
        }
    }

    return null; // return null if validation is passed.
}

@Directive({
  selector: '[appMinoreValidatorDirective]',
  providers: [{
    provide: NG_VALIDATORS,
    useExisting: AppMinoreValidatorDirective,
    multi: true
  }]
})
export class AppMinoreValidatorDirective implements Validator {
  validate(control: AbstractControl) : {[key: string]: any} | null {
    return ValidateMinore(control);
  }
}